import React, { useRef } from 'react';
var VeltNotificationsPanelContentPeopleListItemName = function (props) {
    var data = props.data, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-people-list-item-name", { ref: ref, data: data ? (typeof data === "string" ? data : JSON.stringify(data)) : undefined }, children));
};
export default VeltNotificationsPanelContentPeopleListItemName;
